import { Flex, Loader } from '@mantine/core';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthLoading, useAuthLoggedIn } from '../providers/AuthProvider.tsx';

const ProtectedRoute = ({ children }: any) => {
  const location = useLocation();
  const isLoading = useAuthLoading();
  const isLoggedIn = useAuthLoggedIn();

  if (isLoading) {
    return (
      <Flex style={{ minHeight: '100vh' }} justify={'center'} align={'center'}>
        <Loader />
      </Flex>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to={`/login${location.search}`} replace />;
  }

  return children;
};

export default ProtectedRoute;
